import { OpportunityOffer as OpportunityOfferProto } from '@taxfyle/api-internal/internal/opportunity_pb'
import type {
  OfferExpirationAction,
  OpportunityOfferConsultation,
} from './OpportunityOffer'
import { mapIntervalProtoToTimeRange } from '@/features/opportunities/opportunity-mappers'
import { durationToMinutes } from '@/utils/grpc-util'

/**
 * Maps an offer's consultation, splitting the client's availability into
 * slots of the requested length.
 */
export function mapOpportunityOfferConsultationProtoToConsultation(
  proto: OpportunityOfferProto.Consultation.AsObject,
): OpportunityOfferConsultation {
  const requestedLength = proto.requestedLength
    ? durationToMinutes(proto.requestedLength)
    : 30
  return {
    consultationId: proto.id,
    availabilityTimes: proto.availabilityTimesList
      .map(mapIntervalProtoToTimeRange)
      .flatMap((a) => a.decomposeRangeInIntervals(requestedLength)),
    requestedLength,
  }
}

/**
 * Maps what happens to an offer when it expires.
 */
export function mapExpirationActionProtoToOfferExpirationAction(
  proto: OpportunityOfferProto.ExpirationAction,
): OfferExpirationAction {
  switch (proto) {
    case OpportunityOfferProto.ExpirationAction.ACCEPT:
      return 'Accept'
    case OpportunityOfferProto.ExpirationAction.DECLINE:
      return 'Decline'
    case OpportunityOfferProto.ExpirationAction.UNSPECIFIED:
      throw new Error('Unreachable')
  }
}
